/* eslint-disable no-undef */
import { Fragment, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { fetchWrapper } from '../../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler, fileUploader } from '../../../../../../_helpers/_methods';
import { FormGroup } from '../../../../../../Components/FormGroup/FormGroup';
import { FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { VscLoading } from 'react-icons/vsc';
import { AiFillDelete } from 'react-icons/ai';
import styled from 'styled-components';

function FilesPostEventActivities({
  postEventId,
  postEvent: { attached_documents = [] },
  setPostEvent,
  isCompleted,
  CAN_EDIT
}) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur'
  });
  const [inputArray, setInputArray] = useState([uuidv4()]);
  const [fileObject, setFileObject] = useState({});
  const [attachedDocuments, setAttachedDocuments] = useState(attached_documents);

  const UploadedFilesArray = attachedDocuments.filter((doc) => doc.file_type === 'file');
  const showFileUploader = CAN_EDIT && !isCompleted && UploadedFilesArray.length <= 40;
  const AvialableFilesUploadSlot = 4 - UploadedFilesArray.length;

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleAddInputFile = () => {
    setInputArray((prev) => [...prev, uuidv4()]);
  };

  const handelRemoveInputFile = (removedInputId) => {
    let tempInputArray = [...inputArray];
    tempInputArray = tempInputArray.filter((inputId) => inputId !== removedInputId);
    setInputArray(tempInputArray);

    let tempFileObject = { ...fileObject };
    delete tempFileObject[removedInputId];
    setFileObject(tempFileObject);
  };

  const handleFileLoad = (file, inputId) => {
    let tempFileObject = { ...fileObject };
    tempFileObject[inputId] = file;
    setFileObject(tempFileObject);
  };

  const onSubmit = async () => {
    try {
      if (postEventId) {
        setIsUploading(true);
        let FileArray = Object.values(fileObject);
        let fileIdArray = [];
        let fileCount = 0;
        let totalFileCount = FileArray.length;
        for (const file of FileArray) {
          fileCount++;
          const { ids } = await fileUploader(file, 'file');
          fileIdArray.push(ids[0]);
          setUploadProgress((fileCount / totalFileCount) * 100);
        }
        if (fileIdArray.length > 0) {
          const res = await fetchWrapper.post(`/event/post/${postEventId}/add_document/`, {
            documents: fileIdArray
          });
          setPostEvent((prevState) => {
            const tempState = { ...prevState };
            if (!tempState.attached_documents) {
              tempState.attached_documents = [];
            }
            tempState.attached_documents.push(...res.data);
            return tempState;
          });
          setFileObject({});
          setInputArray([uuidv4()]);
          toast.success(<FormattedMessage id="add_successfully" />);
        }
        setIsUploading(false);
      }
    } catch (e) {
      console.log(e);
      setIsUploading(false);
      toast.error('Something went wrong');
    }
  };

  const handleDeleteFile = async (id) => {
    try {
      const response = await fetchWrapper.post(`/event/post/delete-document/`, {
        documents: [id]
      });
      let tempAttachedDocuments = [...attachedDocuments];
      tempAttachedDocuments = tempAttachedDocuments.filter((doc) => doc.id !== id);
      setAttachedDocuments(tempAttachedDocuments);
      toast.success(<FormattedMessage id="successfully_deleted" />);
      console.log(response, 'response');
    } catch (e) {
      ErrorMessageHandler(e);
    }
  };
  return (
    <div>
      <h4 className="text-primary mb-4">
        <FormattedMessage id="postEventActivities.files" />
      </h4>
      <Fragment>
        {showFileUploader && (
          <Form className="edit_post_event_activity" onSubmit={handleSubmit(onSubmit)}>
            <>
              {inputArray.map((inputId) => {
                return (
                  <div key={inputId} className="mb-2 d-flex align-items-center border rounded">
                    <FormGroup
                      type="file"
                      id={`document_file[${inputId}]`}
                      register={register}
                      error={errors}
                      disabled={isCompleted}
                      onChange={(e) => handleFileLoad(e.target.files, inputId)}
                    />
                    {!isUploading && inputArray.length > 1 && (
                      <Button
                        variant="outline-danger"
                        className="ms-2"
                        onClick={() => handelRemoveInputFile(inputId)}>
                        <FormattedMessage id="remove_files" />
                      </Button>
                    )}
                  </div>
                );
              })}

              {!isUploading && AvialableFilesUploadSlot > inputArray.length && (
                <div className="col-md-4 pt-1 text-left">
                  <Button
                    type="button"
                    variant="outline-primary"
                    onClick={handleAddInputFile}
                    className=" newFileBtn mb-2 btn-sm px-4">
                    + <FormattedMessage id="add_files" />
                  </Button>
                </div>
              )}

              <div>
                {isUploading && (
                  <div className="text-center">
                    <progress
                      className="w-100"
                      key={uploadProgress}
                      value={uploadProgress}
                      max="100"
                    />
                  </div>
                )}
              </div>
              <div className="d-flex w-100 justify-content-end">
                <Button type="submit" disabled={isUploading} variant="success" className="px-4">
                  {isUploading ? (
                    <VscLoading className="spin" />
                  ) : (
                    <FormattedMessage id="button.submit" />
                  )}
                </Button>
              </div>
            </>
          </Form>
        )}

        {UploadedFilesArray?.length > 0 ? (
          <div className={!showFileUploader ? 'mt-5 mb-3' : ' mb-3'}>
            <h3 className="sub-title mb-2">
              <FormattedMessage id="all_files" />
            </h3>
            <div className="row">
              {UploadedFilesArray.map((doc) => (
                <div key={doc.id} className="col-md-3 mb-2">
                  <StyledFile
                    className="p-3"
                    style={{
                      borderRadius: '8px',
                      backgroundColor: '#f5f5f5'
                    }}>
                    <h6 className="mb-3">{doc.filename}</h6>
                    <a
                      href={process.env.REACT_APP_BASE_URL + doc.file}
                      target="_blank"
                      rel="noreferrer">
                      <Button variant="outline-secondary">
                        <FormattedMessage id="button.download" />
                      </Button>
                    </a>
                    {showFileUploader && (
                      <Button
                        className="delete-btn"
                        variant="outline-danger"
                        onClick={() => handleDeleteFile(doc.id)}>
                        <AiFillDelete />
                      </Button>
                    )}
                  </StyledFile>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="mt-3 alert alert-warning">
            <FormattedMessage id="no_files_uploaded" />
          </div>
        )}
      </Fragment>
    </div>
  );
}

export default FilesPostEventActivities;

const StyledFile = styled.div`
  position: relative;
  :hover {
    .delete-btn {
      opacity: 1;
      color: #dc3545;
    }
  }
  .delete-btn {
    position: absolute;
    background-color: whitesmoke;
    top: 0;
    right: 0;
    opacity: 0;
    transistion: opacity 0.3s ease-in-out;
  }
`;
